import { Line3 } from "@base/math/Line3";
import { IVec3 } from "@base/math/Vec3";

export class SunSailMath {
  static calcNearestAxlePoint(axleFirst: IVec3, axleSecond: IVec3, p: IVec3): IVec3 {
    const nearestPoint = Line3.getNearestPoint(axleFirst, axleSecond, p, true);
    return nearestPoint;
  }

  static calcGroundRotationFromVec(vec: IVec3): number {
    const rotationY = Math.PI - Math.atan2(-vec.x, vec.z);
    return rotationY;
  }
}